import { RouteSummaryResponse } from 'src/app/core/models/operations';

export enum ColumnIds {
  ROUTE = 'route',
  TOTAL_DELIVERY_STOPS = 'deliveryStops.total',
  COMPLETED_DELIVERY_STOPS = 'deliveryStops.completed',
  PENDING_DELIVERY_STOPS = 'deliveryStops.pending',
  TOTAL_DELIVERY_VOLUME = 'deliveryVolume.total',
  COMPLETED_DELIVERY_VOLUME = 'deliveryVolume.completed',
  PENDING_DELIVERY_VOLUME = 'deliveryVolume.pending',
  TOTAL_PICKUP_STOPS = 'pickupStops.total',
  COMPLETED_PICKUP_STOPS = 'pickupStops.completed',
  PENDING_PICKUP_STOPS = 'pickupStops.pending',
  COMPLETED_PICKUP_VOLUME = 'pickupVolume.completed',
  ROUTE_COMPLETION_STOPS = 'routeCompletionStatus.stops',
  ROUTE_COMPLETION_VOLUME = 'routeCompletionStatus.volume',
}

export const ColumnText = {
  Route: $localize`Route`.toUpperCase(),
  Total: $localize`Total`.toUpperCase(),
  Completed: $localize`Completed`.toUpperCase(),
  Pending: $localize`Pending`.toUpperCase(),
  Stops: $localize`Stops`.toUpperCase(),
  Volume: $localize`Volume`.toUpperCase(),
  Delivery_stops: $localize`Delivery Stops`.toUpperCase(),
  Delivery_volume: $localize`Delivery Volume`.toUpperCase(),
  Pickup_stops: $localize`Pickup Stops`.toUpperCase(),
  Pickup_volume: $localize`Pickup Volume`.toUpperCase(),
  Route_completion_status: $localize`Route Complete Status`.toUpperCase(),
};

export const ExcelHeader = [
  $localize`Route`.toUpperCase(),
  $localize`TOTAL DELIVERY STOPS`,
  $localize`COMPLETED DELIVERY STOPS`,
  $localize`PENDING DELIVERY STOPS`,
  $localize`TOTAL DELIVERY VOLUME`,
  $localize`COMPLETED DELIVERY VOLUME`,
  $localize`PENDING DELIVERY VOLUME`,
  $localize`TOTAL PICKUP STOPS`,
  $localize`COMPLETED PICKUP STOPS`,
  $localize`Pending Pickup Stops`.toUpperCase(),
  $localize`COMPLETED PICKUP VOLUME`,
];

export const EXCEL_FILE_NAME = 'operations-summary-data.csv';

export const MOCK_ROUTE_SUMMARY_RESPONSE: RouteSummaryResponse = {
  response: {
    routesummary: [
      {
        route: '121',
        deliveryStops: {
          total: 0,
          completed: 0,
          pending: 0,
          stops: 0,
          volume: 0,
        },
        deliveryVolume: {
          total: 0,
          completed: 0,
          pending: 0,
          stops: 0,
          volume: 0,
        },
        routeCompletionStatus: {
          total: 0,
          completed: 0,
          pending: 0,
          stops: 0,
          volume: 0,
        },
      },
    ],
  },
};

export type ExportSummaryType = {
  route: string;
  totalDeliveryStops?: number;
  completedDeliveryStops?: number;
  pendingDeliveryStops?: number;
  totalDeliveryVolume?: number;
  completedDeliveryVolume?: number;
  pendingDeliveryVolume?: number;
  totalPickupStops?: number;
  completedPickupStops?: number;
  pendingPickupStops?: number;
  completedPickupVolume?: number;
};
